import { Button, Divider, SwipeableDrawer, IconButton } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import CloseIcon from '@material-ui/icons/Close';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import React, { useState } from 'react';
import { useObservable } from 'react-use-observable';
import { helperPagesFactory } from 'v2/services/helperPage';

import type { IHelperPage } from 'v2/interfaces/helperPage';

import NoDangerouslyHTML from '../NoDangerouslyHTML';
import useStyles from './styles';

const HelperPage = ({ title, name, id }: { title: string; name: string; id: string }) => {
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);
  const [openHint, setOpenHint] = useState<boolean>(false);
  const [helpers] = useObservable(() => helperPagesFactory.loadHelperPage(name), []);
  const [currentHint, setCurrentHint] = useState<IHelperPage>(null);

  const onClose = () => {
    setOpen(false);
    setOpenHint(false);
    setCurrentHint(null);
  };

  if (!helpers?.length) return null;

  return (
    <>
      <Button id={id} variant='outlined' onClick={() => setOpen(true)} startIcon={<HelpOutlineIcon />} className={classes.button}>
        Ajuda
      </Button>

      <SwipeableDrawer anchor='right' open={open} onClose={onClose} onOpen={() => null} classes={{ paper: classes.drawer }}>
        <div className={classes.header}>
          {title}
          <IconButton size='small' onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
        {openHint && (
          <div className={classes.back} onClick={() => setOpenHint(false)}>
            <Button size='small' startIcon={<ArrowBackIcon />} variant='text'>
              Voltar para lista
            </Button>
          </div>
        )}
        <div className={classes.container}>
          {openHint ? (
            <div className={classes.containerHint}>
              <div className={classes.title}>{currentHint.name}</div>
              <NoDangerouslyHTML html={currentHint.hint} />
            </div>
          ) : (
            (helpers || []).map((h) => (
              <>
                <div
                  key={h.name}
                  onClick={() => {
                    setCurrentHint(h);
                    setOpenHint(true);
                  }}
                  className={classes.clickable}
                >
                  <p>{h.name}</p>
                  <IconButton size='small' className={classes.clickableButton}>
                    <ArrowForwardIosIcon />
                  </IconButton>
                </div>
                <Divider />
              </>
            ))
          )}
        </div>
      </SwipeableDrawer>
    </>
  );
};

export default HelperPage;
